export const getSellerEditPath = (sellerId: string): string => {
  return `/sellers/${sellerId}`
}